import { ObservableFromFetch } from "../ObservableFromFetch"
import NotificationDetails from "./Model/NotificationDetails"
import NotificationEvent from "./Model/NotificationEvent"
import NotificationMethod from "./Model/NotificationMethod"
import NotificationAccountService from "./Model/NotificationAccountService"

export default function NotificationDetailGet() {
  return ObservableFromFetch<NotificationDetails>("FFOrderClinicStatus/GetNotificationDetail")
}

export function NotificationServicesGet(participationId?: number) {
  const params = JSON.stringify({
    ParticipationId: participationId
  })
  return ObservableFromFetch<NotificationAccountService[]>("WorkforceNotification/GetNotificationServices", params)
}

export function NotificationEventsGet() {
  return ObservableFromFetch<NotificationEvent[]>("WorkforceNotification/GetNotificationEvents")
}

export function NotificationMethodsGet() {
  return ObservableFromFetch<NotificationMethod[]>("WorkforceNotification/GetNotificationMethods")
}
